export default __webpack_public_path__ + "static/media/facedetection_demo_image.8d9808e7.png";